import React, {Component} from "react";
import {Growl} from 'primereact/growl';
import ActiveGuaranteesDetailView from "./ActiveGuaranteesDetailView";
import {ReportsService} from "../../../service/reports/ReportsService";
import {Column} from "primereact/column";
import {DataTable} from "primereact/datatable";
import ConfirmationMessage from "../../../components/confirmationMessage";
import {dateFormatterReportTable} from "../../../utils/formatters/Date";
import {rateDataTableTemplate} from "../../../utils/formatters/Numbers";

export default class ActiveGuaranteesDetailContainer extends Component {
    constructor(props) {
        super(props);

        this.reportsService = new ReportsService();
        this.getDataReport = this.getDataReport.bind(this);
        this.exportDocument = this.exportDocument.bind(this);
        this.confirmationRef = null;
        this.today = new Date();
        this.setConfirmationRef = element => {
            this.confirmationRef = element
        };

        let columns = [
            {field: "fechaConsulta", header: "Fecha Consulta", body: dateFormatterReportTable},
            {field: "folioOperacion", header: "Folio", style: {textAlign: 'right', width: '100px'}},
            {field: "fechaConcertacion", header: "Fecha Concert", body: dateFormatterReportTable},
            {field: "fechaValor", header: "Fecha Valor", body: dateFormatterReportTable},
            {field: "horaConcertacion", header: "Hora Concertación"},
            {field: "fechaVencimiento", header: "Fecha Vencimiento", body: dateFormatterReportTable},
            {field: "plazoOperacion", header: "Plazo", style: {textAlign: 'right', width: '50px'}},
            {field: "instPTM", header: "PTM"},
            {field: "cuentaPTM", header: "Cuenta PTM"},
            {field: "instPTT", header: "PTT"},
            {field: "emisora", header: "Emisora"},
            {field: "tipoValor", header: "Clave"},
            {field: "serie", header: "Serie"},
            {field: "cupon", header: "Cupón"},
            {field: "cantidadTitulos", header: "Títulos", style: {textAlign: 'right', width: '100px'}},
            {field: "monedaOperacion", header: "Moneda"},
            {field: "precioPactado", header: "Precio", style: {textAlign: 'right', width: '100px'}},
            {field: "sobretasa", header: "Sobretasa", style: {textAlign: 'right', width: '70px'}},
            {field: "importe", header: "Importe", style: {textAlign: 'right', width: '100px'}},
            {field: "tasa", header: "Tasa", style: {textAlign: 'right', width: '60px'}},
            {field: "premio", header: "Premio", style: {textAlign: 'right', width: '100px'}},
            {field: "status", header: "Estatus", style: {textAlign: 'left', width: '60px'}},
        ];

        this.state = {
            isLoading: false,
            cols: columns,
            filters: {
                guaranteeCheck: true,
                isinColumn: false,
                startDate: this.today,
                finalDate: this.today,
                today: this.today,
            },
            dataReport: [],
            exportOptions: [
                {
                    label: "Excel", action: () => {
                        this.openConfirmationMessage("Excel")
                    }
                },
                {
                    label: "PDF", action: () => {
                        this.openConfirmationMessage("PDF")
                    }
                },
                {
                    label: "CSV", action: () => {
                        this.openConfirmationMessage("CSV")
                    }
                },
            ],
            typeDocument: '',
            disabledSearchButton: false,
        };

        this.onChangeFilters = this.onChangeFilters.bind(this);
        this.rowExpansionTemplate = this.rowExpansionTemplate.bind(this);
        this.openConfirmationMessage = this.openConfirmationMessage.bind(this);
        this.clearFilters = this.clearFilters.bind(this);
        this.loading = this.loading.bind(this);
    }

    componentDidMount() {
        let message = this.props.location.message ? this.props.location.message : null;
        if (message !== null && message.severity) {
            this.growl.show({
                severity: message.severity ? message.severity : '',
                summary: message.summary ? message.summary : '',
                detail: message.detail ? message.detail : '', message
            });
        }
    }

    loading(option) {
        if (this.state !== undefined) {
            this.setState({
                isLoading: option ? option : false,
            });
        }
    }

    clearFilters() {
        let colsAux = JSON.parse(JSON.stringify(this.state.cols));
        this.state.cols.forEach((item)=>{
            if(item.field === "isin"){
                colsAux.splice(14, 1);
            }
        });

        this.setState({
            cols: colsAux,
            filters: {
                guaranteeCheck: true,
                isinColumn: false,
                startDate: this.today,
                finalDate: this.today,
                today: this.today,
            },
        });
    }

    onChangeFilters(event) {
        let colsAux = this.state.cols;
        let filtersAux = this.state.filters;

        switch (event.target.name) {
            case "isinColumn":
                event.checked ?
                    colsAux.splice(14, 0,
                        {field: "isin", header: "ISIN"}) :
                    colsAux.splice(14, 1);
                filtersAux[event.target.name] = event.checked;
                break;
            case "guaranteeCheck":
                filtersAux[event.target.name] = event.checked;
                break;
            case "startDate":
                filtersAux[event.target.name] = event.target.value;
                filtersAux['finalDate'] = event.target.value;
                break;
            default:
                filtersAux[event.target.name] = event.target.value;
                break;
        }

        this.setState({
            cols: colsAux,
            filters: filtersAux,
        });
    }

    rowExpansionTemplate(data) {
        const guaranteesItems = data.guaranteesList;
        return (
            <div className="p-grid">
                <div className="p-col-1"/>
                <div className="p-col-11">
                    <DataTable
                        tableClassName={"guarantees-column-header"}
                        value={guaranteesItems}
                        responsive={true}
                        resizableColumns={true}
                        columnResizeMode={"fit"}>
                        <Column field="date" header="Fecha" style={{textAlign: 'left'}} body={dateFormatterReportTable}
                                sortable={true}/>
                        <Column field="date" header="Fecha" style={{textAlign: 'left'}} body={dateFormatterReportTable}
                                sortable={true}/>
                        <Column field="source" header="Origen" style={{textAlign: 'left'}} sortable={true}/>
                        <Column field="type" header="Tipo" style={{textAlign: 'left'}} sortable={true}/>
                        <Column field="coin" header="Moneda" style={{textAlign: 'left'}} sortable={true}/>
                        <Column field="emisora" header="Emisora" style={{textAlign: 'left'}} sortable={true}/>
                        <Column field="clave" header="Clave" style={{textAlign: 'left'}} sortable={true}/>
                        <Column field="serie" header="Serie" style={{textAlign: 'left'}} sortable={true}/>
                        <Column field="cupon" header="Cupón" style={{textAlign: 'left'}} sortable={true}/>
                        <Column field="cuentaPTT" header="Cuenta PTT" style={{textAlign: 'left'}} sortable={true}/>
                        <Column field="titles" header="Títulos" style={{textAlign: 'right'}} sortable={true}/>
                        <Column field="price" header="Precio" style={{textAlign: 'right'}} sortable={true}/>
                        <Column field="guaranteeAmount" header="Imp. Garantizado" style={{textAlign: 'right'}}
                                sortable={true}/>
                        <Column field="guaranteeTotal" header="Tot. Garantizado" style={{textAlign: 'right'}}
                                sortable={true}/>
                        <Column field="guaranteePercentage" header="% Garantizado" style={{textAlign: 'right'}}
                                body={rateDataTableTemplate} sortable={true}/>
                    </DataTable>
                </div>
            </div>

        );
    }

    openConfirmationMessage(docType) {
        if (this.confirmationRef) {
            this.setState({
                typeDocument: docType
            });
            this.confirmationRef.openConfirmationMessage();
        }
    }

    getDataReport() {
        this.loading(true);
        this.setState({
            disabledSearchButton: true,
        });
        this.reportsService.getGuaranteeActiveDetailReport(this.state.filters)
            .then(resp => {
                let expandedRowsAux = [];
                if (resp.error !== '') {
                    this.growl.show({
                        severity: 'info', summary: 'Atención.',
                        detail: resp.error
                    });
                } else {
                    if (this.state.filters.guaranteeCheck) {
                        resp.payload.map((row) => {
                            return (row.guaranteesList.length === 0 ? '' : expandedRowsAux.push(row));
                        });
                    }
                }
                this.setState({
                    dataReport: resp.payload,
                    expandedRows: expandedRowsAux,
                    disabledSearchButton: false,
                });
                this.loading(false);
            });
    }

    exportDocument() {
        this.loading(true);
        if (this.state.dataReport.length === 0) {
            this.growl.show({
                severity: 'info', summary: 'Atención.',
                detail: 'No existen datos'
            });
            this.loading(false);
        } else {
            let params = {
                bandera: 0,
                tipoReporte: 4,
                fechaInicial: this.state.filters.startDate.getFullYear() + "-" +
                    (this.state.filters.startDate.getMonth() + 1) + "-" +
                    this.state.filters.startDate.getDate(),
                fechaFinal: this.state.filters.finalDate.getFullYear() + "-" +
                    (this.state.filters.finalDate.getMonth() + 1) + "-" +
                    this.state.filters.finalDate.getDate(),
                chkISIN: this.state.filters.isinColumn,
                chkGarantia: this.state.filters.guaranteeCheck,
            };
            switch (this.state.typeDocument) {
                case "Excel":
                    this.reportsService.getHistoricalReportXLS(params)
                        .then(res => {
                            this.getDataReport();
                            this.loading(false);
                        });
                    break;
                case "PDF":
                    this.reportsService.getHistoricalReportPDF(params)
                        .then(res => {
                            this.getDataReport();
                            this.loading(false);
                        });
                    break;
                case "CSV":

                    params = {
                        accion: 18012,//accion en servlet
                        band: this.state.filters.guaranteeCheck,//con garantias
                        bandera: false,//con comision
                        bandIsin: false,
                        bandCuenta: false,
                        par: 2,//tipo de reporte
                        fechaInicial: this.state.filters.startDate.getDate() + "-" +
                            (this.state.filters.startDate.getMonth() + 1) + "-" +
                            this.state.filters.startDate.getFullYear(),
                        fechaFinal: this.state.filters.finalDate.getDate() + "-" +
                            (this.state.filters.finalDate.getMonth() + 1) + "-" +
                            this.state.filters.finalDate.getFullYear(),
                    };

                    this.reportsService.getHistoricalReportCSV(params)
                        .then(res => {
                            this.getDataReport();
                            this.loading(false);
                        });
                    break;
                default:
                    break;
            }
        }
    }

    render() {
        let confMsg = <ConfirmationMessage ref={this.setConfirmationRef}
                                           invisible={true}
                                           legend="¿Usted está seguro de continuar descargando la información solicitada?"
                                           action={this.exportDocument}/>;
        let messagesGrowl = <Growl ref={(el) => this.growl = el}/>;
        const {
            dataReport, isLoading, columnSelected, expandedRows,
            filters, exportOptions, disabledSearchButton
        } = this.state;
        let columns = this.state.cols.map((col, i) => {
            return <Column field={col.field}
                           header={col.header}
                           style={col.style ? col.style : {textAlign: 'left', width: '100px'}}
                           sortable={true}
                           body={col.body ? col.body : ''}
            />;
        });

        return <ActiveGuaranteesDetailView
            dataReport={dataReport}
            isLoading={isLoading}
            messagesGrowl={messagesGrowl}
            columns={columns}
            filters={filters}
            columnSelected={columnSelected}
            expandedRows={expandedRows}
            exportOptions={exportOptions}
            confMsg={confMsg}
            disabledSearchButton={disabledSearchButton}
            onChangeFilters={this.onChangeFilters}
            rowExpansionTemplate={this.rowExpansionTemplate}
            getDataReport={this.getDataReport}
            clearFilters={this.clearFilters}
        />
    }
};